var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h3',[_vm._v(_vm._s(_vm.getProgramDetails.programName || ''))]),(!_vm.reload)?_c('TransactionList',{attrs:{"baseCrudKey":_vm.getProgramDetails.baseCrudKey}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }